import { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { disablePush, enablePush, pushState } from "@/lib/push";

const COPY = {
  "ios-install": "On iPhone: tap Share → Add to Home Screen, then open Scoopz from your Home Screen to turn on push.",
  unsupported: "This browser doesn't support push notifications.",
  denied: "Push is blocked — allow notifications for this site in your browser settings.",
};

export function PushToggle() {
  const [state, setState] = useState("loading");
  const refresh = () => pushState().then(setState).catch(() => setState("unsupported"));
  useEffect(() => { refresh(); }, []);
  const toggle = async () => {
    try {
      if (state === "on") await disablePush();
      else await enablePush();
      toast.success(state === "on" ? "Push notifications off" : "Push notifications on");
    } catch (e) {
      toast.error(e.message);
    }
    refresh();
  };
  if (COPY[state]) return <p className="px-4 py-2 text-xs text-muted-foreground" data-testid="push-unavailable">{COPY[state]}</p>;
  return (
    <button type="button" onClick={toggle} disabled={state === "loading"} data-testid="push-toggle-button"
      className="flex w-full items-center gap-2 px-4 py-2.5 text-left text-xs font-semibold text-neon-cyan hover:bg-muted">
      <BellRing className="h-4 w-4" /> {state === "on" ? "Push notifications on — turn off" : "Turn on push notifications"}
    </button>
  );
}
